import { FunctionComponent, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { TabButton } from "@ui-kit/TabButton/TabButton";
import { Text } from "@ui-kit/Text/Text";
import { Banner } from "../Banner/Banner";
import { useSessionReset } from "../../../../hooks/useSessionReset/useSessionReset";

import "./NewPlanBanner.css";

const NewPlanBanner: FunctionComponent = () => {
  const { t } = useTranslation();
  const resetSession = useSessionReset();

  const onResetPlan = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      resetSession();
    },
    [resetSession],
  );

  return (
    <Banner className={`new-plan-banner`} testId="new-plan-banner">
      <Text variant="fontBodyLarge">{t("newPlanBanner.title")}</Text>
      <TabButton
        variant="primary"
        onPress={onResetPlan}
        label={t("newPlanBanner.resetPlan")}
        size="large"
      />
    </Banner>
  );
};

export { NewPlanBanner };
